import { Typography } from "@mui/material"
import Modal from "../ui/Modal"

const DeleteEvent = (props) => {
  return (
    <Modal {...props} title="Delete Event" actionText="Delete">
      <Typography>
        Do you want to delete event '
        {props.data?.program + " " + props.data?.academicYear}'? <br /> All
        material will be deleted.
      </Typography>
    </Modal>
  )
}

export default DeleteEvent
